export const formatDate = (dateString: string) => {
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: 'numeric',
    timeZone: 'Asia/Kolkata',
  };

  return new Date(dateString).toLocaleString('en-IN', options);
}